import { staticFile } from "remotion";

export const SC_ICONS = [
  {
    id: "analysis1",
    filename: "sc_icon_analysis1_full-colour_rgb_1600px.svg",
    label: "Analysis 1",
  },
  {
    id: "analysis2",
    filename: "sc_icon_analysis2_full-colour_rgb_1600px.svg",
    label: "Analysis 2",
  },
  {
    id: "announcement",
    filename: "sc_icon_announcement_full-colour_rgb.svg",
    label: "Announcement",
  },
  {
    id: "career-path-advancement",
    filename: "sc_icon_career-path-advancement_full-colour_rgb.svg",
    label: "Career Path Advancement",
  },
  {
    id: "diversity",
    filename: "sc_icon_diversity_full-colour_rgb.svg",
    label: "Diversity",
  },
  {
    id: "finance-data-2",
    filename: "sc_icon_finance-data-2_full-colour_rgb_1600px.svg",
    label: "Finance Data",
  },
  {
    id: "growth-1",
    filename: "sc_icon_growth-1_full-colour_rgb_1600px.svg",
    label: "Growth 1",
  },
  {
    id: "growth-3",
    filename: "sc_icon_growth-3_full-colour_rgb_1600px.svg",
    label: "Growth 3",
  },
  {
    id: "leadership",
    filename: "sc_icon_leadership_full-colour_rgb.svg",
    label: "Leadership",
  },
  {
    id: "learning-training-1",
    filename: "sc_icon_learning-training-1_full-colour_rgb.svg",
    label: "Learning Training 1",
  },
  {
    id: "learning-training-2",
    filename: "sc_icon_learning-training-2_full-colour_rgb.svg",
    label: "Learning Training 2",
  },
  {
    id: "performance",
    filename: "sc_icon_performance_full-colour_rgb.svg",
    label: "Performance",
  },
  {
    id: "portfolio-2",
    filename: "sc_icon_portfolio-2_full-colour_rgb_1600px.svg",
    label: "Portfolio",
  },
  {
    id: "recruitment",
    filename: "sc_icon_recruitment_full-colour_rgb.svg",
    label: "Recruitment",
  },
  {
    id: "stock-market-1",
    filename: "sc_icon_stock-market-1_full-colour_rgb_1600px.svg",
    label: "Stock Market 1",
  },
  {
    id: "stock-market-2",
    filename: "sc_icon_stock-market-2_full-colour_rgb_1600px.svg",
    label: "Stock Market 2",
  },
  {
    id: "teamwork-1",
    filename: "sc_icon_teamwork-1_full-colour_rgb.svg",
    label: "Teamwork 1",
  },
  {
    id: "teamwork-2",
    filename: "sc_icon_teamwork-2_full-colour_rgb.svg",
    label: "Teamwork 2",
  },
  {
    id: "teamwork-3",
    filename: "sc_icon_teamwork-3_full-colour_rgb.svg",
    label: "Teamwork 3",
  },
];

export const DEFAULT_ICONS = [
  "sc_icon_analysis1_full-colour_rgb_1600px.svg",
  "sc_icon_growth-1_full-colour_rgb_1600px.svg",
  "sc_icon_stock-market-1_full-colour_rgb_1600px.svg",
];

export const resolveIconFilename = (keyOrPath) => {
  if (!keyOrPath || typeof keyOrPath !== "string") return null;
  const cleaned = keyOrPath.trim();
  if (!cleaned) return null;

  const basename = cleaned.split("/").pop().split("\\").pop();
  const svgBasename = basename.replace(/\.png$/i, ".svg");

  // 1. Direct filename match
  const foundByFilename = SC_ICONS.find(
    (item) =>
      item.filename.toLowerCase() === svgBasename.toLowerCase() ||
      item.filename.toLowerCase() === basename.toLowerCase()
  );
  if (foundByFilename) return foundByFilename.filename;

  // 2. Direct ID match
  const foundById = SC_ICONS.find(
    (item) => item.id.toLowerCase() === cleaned.toLowerCase()
  );
  if (foundById) return foundById.filename;

  // 3. Normalized stripped match (remove extension, prefix 'sc_icon_', underscores vs dashes)
  const normalize = (str) =>
    str
      .replace(/\.(png|svg)$/i, "")
      .replace(/^sc_icon_/i, "")
      .replace(/_/g, "-")
      .toLowerCase();

  const targetNorm = normalize(basename);
  const foundByNorm = SC_ICONS.find((item) => {
    return (
      normalize(item.filename) === targetNorm ||
      normalize(item.id) === targetNorm
    );
  });
  if (foundByNorm) return foundByNorm.filename;

  // Fallback to basename if it contains sc_icon
  if (basename.startsWith("sc_icon")) {
    return svgBasename;
  }

  return null;
};

export const resolveIconSrc = (keyOrPath, fallbackIndex = 0) => {
  if (!keyOrPath) {
    const fallbackFilename = DEFAULT_ICONS[fallbackIndex % DEFAULT_ICONS.length];
    return staticFile(`icons/${fallbackFilename}`);
  }

  // If already absolute URL or data URL
  if (
    typeof keyOrPath === "string" &&
    (keyOrPath.startsWith("http://") ||
      keyOrPath.startsWith("https://") ||
      keyOrPath.startsWith("data:"))
  ) {
    return keyOrPath;
  }

  const filename = resolveIconFilename(keyOrPath);
  if (filename) {
    const svgFilename = filename.replace(/\.png$/i, ".svg");
    return staticFile(`icons/${svgFilename}`);
  }

  const fallbackFilename = DEFAULT_ICONS[fallbackIndex % DEFAULT_ICONS.length];
  return staticFile(`icons/${fallbackFilename}`);
};
